import {OptimizationType, RoutingPayload, RoutingType,} from "./routing-request";
import {CarType} from "./vehicle";

export const initRoutingRequest: RoutingPayload = {
    targetDate: new Date(),
    routingType: RoutingType.PickupAndDelivery,
    optimizationType: OptimizationType.MinDistance,
    vehicles: [
        {
            vehicleName: "배송원01",
            workTimeWindow: {
                startTimeLimited: {
                    hour: "",
                    minute: "",
                },
                endTimeLimited: {
                    hour: "",
                    minute: "",
                },
            },
            car: {
                carType: CarType.Ray,
                maxCapacity: 100,
            },
            startPlace: {
                placeName: "",
                road: "",
                latitude: 0,
                longitude: 0,
            },
            endPlace: {
                placeName: "",
                road: "",
                latitude: 0,
                longitude: 0,
            },
        },
    ],
    tasks: [
        {
            taskName: "물류01",
            pickUpPlace: {
                placeName: "",
                road: "",
                latitude: 0,
                longitude: 0,
            },
            pickUpTimeWindow: {
                startTimeLimited: {
                    hour: "",
                    minute: "",
                },
                endTimeLimited: {
                    hour: "",
                    minute: "",
                },
            },
            pickUpServiceTime: "",
            dropOffPlace: {
                placeName: "",
                road: "",
                latitude: 0,
                longitude: 0,
            },
            dropOffTimeWindow: {
                startTimeLimited: {
                    hour: "",
                    minute: "",
                },
                endTimeLimited: {
                    hour: "",
                    minute: "",
                },
            },
            dropOffServiceTime: "",
            capacity: 5,
        },
        {
            taskName: "물류02",
            pickUpPlace: {
                placeName: "",
                road: "",
                latitude: 0,
                longitude: 0,
            },
            pickUpTimeWindow: {
                startTimeLimited: {
                    hour: "",
                    minute: "",
                },
                endTimeLimited: {
                    hour: "",
                    minute: "",
                },
            },
            pickUpServiceTime: "",
            dropOffPlace: {
                placeName: "",
                road: "",
                latitude: 0,
                longitude: 0,
            },
            dropOffTimeWindow: {
                startTimeLimited: {
                    hour: "",
                    minute: "",
                },
                endTimeLimited: {
                    hour: "",
                    minute: "",
                },
            },
            dropOffServiceTime: "",
            capacity: 5,
        },
    ],
};
